import {
  AssignmentConfig,
  EmptyAssignment,
} from "@/types/models/Assignment.interface";

interface Assignment {
  assignment_config: AssignmentConfig;
}

const getAssignmentSetting = (
  configKey: keyof AssignmentConfig,
  assignment: Assignment | undefined | EmptyAssignment,
) => {
  return assignment?.assignment_config?.[configKey] || false;
};

export default getAssignmentSetting;
